import { rootQueryKeys } from '../../resource-roots/queries/rootQueryKeys.js';
import { spaceQueryKeys } from './spacesQueryKeys.js';

const spaceQueryPredicates = {
  space: (query, spaceId) => {
    const resourceKey = spaceQueryKeys.space(spaceId);
    return query.queryKey[0] === resourceKey[0] && query.queryKey[1] === resourceKey[1];
  },
  spacesAll: (query) => {
    return rootQueryKeys.resourceRootList(void 0)[0] === query.queryKey[0];
  }
};

export { spaceQueryPredicates };
//# sourceMappingURL=spaceQueryPredicates.js.map
